var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D75DE",
    fillRule: "nonzero",
    d: "M10 4.999a.842.842 0 0 0-.203-.516l-4-4.25C5.525-.011 5.006-.111 4.703.17c-.299.277-.289.816.008 1.094l2.812 2.985H.75a.75.75 0 0 0 0 1.5h6.773L4.711 8.733c-.256.257-.304.814-.008 1.094.295.28.834.19 1.094-.062l4-4.25A.725.725 0 0 0 10 4.998z"
  })));
}

export default SvgArrow;